<template lang='pug'>
.marketDetail2-container(v-if='!bookMarksLoading')
    topContent(:bigTitle='childMarketName', :else='marketName', :img='img' :marketNameId='marketNameId' :childMarketNameId='childMarketNameId')
    .img-container
        img(:src='img')
    .content1(v-html='data[0].des', v-if='data[0]')
    div(v-if="content && content.length > 0")
        Icon.success(
            name='成功案例',
            src='成功案例@3x.png',
            height='0.85rem',
        )
        //- v-if='data.case_title'
        //- v-show='data[0].case_title',
        .content-container(
            v-for='item in content',
            :key='item.id'
        )
            .top-container
                .title {{ item.title }}
                .more(@click='switchVisible($event,0)') 了解更多
            .content
                .q(v-html='item.content')
                .bottom 
                    img(src='@/assets/imgs/up@3x.png',)
                    .show(@click='switchVisible($event,1)') 收起
                    //-  @click='active = !active'
    Icon.tuijian(
        name='产品推荐',
        src='产品推荐@3x.png',
        height='0.65rem',
        v-if='swiper.length'
    )
    .swiper-container1(v-if='swiper.length')
        swiper(:options='swiperOption') 
            swiperSlide.item(
                v-for='(item, index) in swiper',
                :key='index',
                @click.native='jump(item.pid, item.id, item.smallTitle)'
            )
                .item-top
                    img(v-src='item.img')
                .item-bottom
                    .big {{ item.bigTitle }}
                    .small {{ item.smallTitle }}
            .swiper-button-prev(slot='button-prev')
            .swiper-button-next(slot='button-next')
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/swiper-bundle.css'
import Icon from './components/icon'
import topContent from './components/topContent'
import { mapState } from 'vuex';
import icon1 from '@/assets/imgs/应用场景@3x.png'
import icon2 from '@/assets/imgs/产品@3x.png'
import icon3 from '@/assets/imgs/概述@3x.png'
import icon4 from '@/assets/imgs/解决方案@3x.png'
import icon5 from '@/assets/imgs/价值@3x.png'
import icon6 from '@/assets/imgs/产品优势@3x.png'
import { getDataHierarchy, getDataRows, getDataHierarchies, concatWithSymbol } from '@custouch/proxy-use'
import { getCmsStr,getPath } from './levelTitle'
export default {
    name: 'marketDetail2',
    props: ['childMarketNameId', 'marketNameId'],
    components: {
        topContent, Icon, swiper, swiperSlide
    },
    computed: {
        ...mapState(['bookMarks', 'memberInfo', 'bookMarksLoading']),
    },
    async created() {
        const { module, template } = window.env.VITE_DATA
        const [childMarketData,marketData,productList,caseList,productTypeList] = await Promise.all([getDataHierarchy({dataHierarchyId: this.childMarketNameId}),getDataHierarchy({dataHierarchyId: this.marketNameId}),getDataRows({dataTemplateId:template.product, dataHierarchyId: this.childMarketNameId, index: 1, size: 99}),getDataRows({dataTemplateId:template.case, dataHierarchyId: this.childMarketNameId, index: 1, size: 99}),getDataHierarchies(module.product)])
        this.marketName = marketData.name
        this.childMarketName = childMarketData.name
        const { path } = await getPath(this.childMarketNameId,this.$route.meta.mId)
        const cms = getCmsStr({mId: this.$route.meta.mId,hId: this.childMarketNameId})
        this.$root.$emit('pageview',{title:concatWithSymbol([this.$route.meta.title,path]),cms})
        this.$root.$emit('updateShare', { title: this.childMarketName + '-' + document.title })
        this.$root.$emit('action', { name: this.$route.name, marketName: this.marketName, childMarketName: this.childMarketName, childMarketNameId: this.childMarketNameId, marketNameId: this.marketNameId })
        this.data = []
        let param = {
            biamge: childMarketData.detail.bigimg ? childMarketData.detail.bigimg : '',
            case_content: childMarketData.detail.case_content ? childMarketData.detail.case_content : '',
            case_title: childMarketData.detail.case_title ? childMarketData.detail.case_title : '',
            des: childMarketData.detail.content ? childMarketData.detail.content : ''
        }
        this.data.push(param)
        this.img = this.data[0].biamge.split(";")[0]
        this.content = caseList.data.map((val,index)=>{
            return {id: index, content: val.detail.case_content, title: val.detail.case_title}
        })
        this.content.forEach(val => {
            val.content = val.content.replace(/\\/g, '')
        })
        this.swiper = productList.data.map(item=>{
            let form = productTypeList.find(i=>i.name === item.detail.title)
            let param = {}
            if(form){
                param.pid = form.id
            }
            return Object.assign({},param,{id:item.id,bigTitle:item.detail.title,smallTitle:item.detail.name,img:item.detail.img})
        })
        await this.$nextTick()
        this.init()
    },
    methods: {
        switchVisible(e,type) {
            const t = e.target
            let content
            if (type == 0) {
                content = e.target.parentNode.nextSibling
            } else {
                content = e.target.parentNode.parentNode
            }
            if (content.style.maxHeight) {
                content.style.maxHeight = null
            } else {
                content.style.maxHeight = content.scrollHeight + 'px'
            }
        },
        jump(pid, id, smallTitle) {
            if (smallTitle) {
                this.$router.push({
                    name: 'introduceDetail2',
                    params: {
                        introduceId:pid,
                        introduceId2:id
                    }
                })
            } else {
                this.$router.push({
                    name: 'introduceDetail',
                    params: {
                        introduceId:pid
                    }
                })
            }

        },
        init() {
            var a = this.$el.getElementsByTagName("span")
            a = Array.from(a)
            for (var i = 0; i < a.length; i++) {
                a[i].style.color = "#00448a"
                if (a[i].innerHTML == "应用场景") {
                    a[i].parentNode.parentNode.style.position = "relative"
                    let img = document.createElement("img")
                    img.src = icon1
                    img.classList.add('icon')
                    a[i].parentNode.parentNode.appendChild(img)
                    if (this.childMarketName == '内饰') {
                        img.style.top = 0
                    }
                } else if (a[i].innerHTML == '产品') {
                    a[i].parentNode.parentNode.style.position = "relative"
                    let img = document.createElement("img")
                    img.src = icon2
                    img.classList.add('icon')
                    a[i].parentNode.parentNode.appendChild(img)
                } else if (a[i].innerHTML == '概述') {
                    a[i].parentNode.parentNode.style.position = "relative"
                    let img = document.createElement("img")
                    img.src = icon3
                    img.classList.add('icon')
                    a[i].parentNode.parentNode.appendChild(img)
                } else if (a[i].innerHTML == '客户的需求及我们提供的解决方案') {
                    a[i].parentNode.parentNode.style.position = "relative"
                    let img = document.createElement("img")
                    img.src = icon4
                    img.classList.add('icon')
                    a[i].parentNode.parentNode.appendChild(img)
                } else if (a[i].innerHTML == '我们产品/方案的独特价值') {
                    a[i].parentNode.parentNode.style.position = "relative"
                    let img = document.createElement("img")
                    img.src = icon5
                    img.classList.add('icon')
                    a[i].parentNode.parentNode.appendChild(img)
                } else if (a[i].innerHTML == '产品优势') {
                    a[i].parentNode.parentNode.style.position = "relative"
                    let img = document.createElement("img")
                    img.src = icon6
                    img.classList.add('icon')
                    a[i].parentNode.parentNode.appendChild(img)
                }
            }
        }
    },
    data() {
        return {
            data: {},
            img: '',
            content: '',
            swiper: [],
            swiperOption: {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 20,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            childMarketName:'',
            marketName:''
        }
    }
}
</script>
<style lang="less">
.content-container {
    .icon {
        display: inline-block;
        width: 0.7rem;
        position: absolute;
        object-fit: contain;
        left: -0.85rem;
        top: 0.2rem;
    }
}
</style>
<style scoped lang='less'>
.swiper-button-next:after {
    content: '';
}
.swiper-button-prev:after {
    content: '';
}
.content1 {
    white-space: pre-wrap;
    font-size: 0.6rem;
    color: #00448a;
    line-height: 1.1rem;
    margin-bottom: 1.2rem;
}
.t1 {
    background: red;
    width: 6.95rem !important;
    margin-right: 0.8rem;
}
.t2 {
    background: green;
    width: 6.95rem !important;
}
.t3 {
    background: grey;
    width: 6.95rem !important;
}
.t4 {
    background: yellow;
    width: 6.95rem !important;
}
.my-swipe .van-swipe-item {
    height: 100px !important;
}
.my-swipe {
    width: 14.7rem;
}
.marketDetail2-container {
    padding-bottom: 1rem;
    .tuijian {
        margin-top: 1.2rem;
        margin-bottom: 0.7rem;
        font-weight: 700;
    }
    .img-container {
        margin-top: 0.5rem;
        height: 9.4rem;
        margin-bottom: 0.6rem;
        img {
            display: block;
            width: 100%;
            border-radius: 0.5rem;
            height: 100%;
        }
    }
    .content-container {
        .q {
            p {
                position: relative;
                img {
                    position: absolute;
                    left: 0rem;
                    width: 0.5rem;
                    height: 0.5rem;
                }
            }

            padding-left: 0.85rem;
            padding-top: 1rem;
            line-height: 1.1rem;
            color: #00448a !important;
            span {
                color: #00448a !important;
            }
        }
        padding: 0.35rem 0.5rem 0.5rem 0.5rem;
        background: #f3f3f3;
        border-radius: 0.2rem;
        margin-bottom: 0.5rem;

        .content {
            transition: all 0.5s;
            max-height: 0rem;
            overflow: hidden;
            .bottom {
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    width: 0.45rem;
                    margin-right: 0.2rem;
                }
                .show {
                    font-size: 0.6rem;
                    color: #219cdc;
                }
            }
        }
        .top-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .more,
            .title {
                color: #219cdc;
                font-size: 0.6rem;
            }
            .title {
                width: 76%;
            }
        }
    }
    .success {
        margin-bottom: 0.8rem;
        font-weight: 700;
    }

    padding-left: 1rem;
    padding-right: 1rem;
    // padding-bottom:2.4rem;
}

.swiper-container1 {
    height: 5.9rem;
    padding-left: 0.9rem;
    padding-right: 0.9rem;
    // padding-bottom: 1rem;
    overflow: hidden;
    .item {
        height: 5.9rem;
        width: 6.95rem;

        border-radius: 0.2rem;
        background: #ebebeb;
        .item-top {
            width: 100%;
            height: 4.15rem;
            border-bottom: 1px solid #ffffff;
            img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
                border-radius: 0.3rem;
            }
        }
        .item-bottom {
            padding-top: 0.35rem;
            .big {
                font-size: 0.5rem;
                line-height: 0.4rem;
                text-align: center;
                color: rgba(33, 156, 220, 1);
                margin-bottom: 0.1rem;
            }
            .small {
                font-size: 0.45rem;
                text-align: center;
                color: rgba(123, 123, 123, 1);
            }
        }
    }
}
.swiper-container {
    overflow: initial;
}
.swiper-button-nex {
    position: absolute;
    top: 0;
    z-index: 999;
}
.swiper-button-prev {
    height: 1rem;
    width: 1rem;
    background: url('../assets/imgs/left@3x.png') no-repeat center/contain;
    left: -1.1rem;
    margin-top: -0.3rem;
    outline: none;
}
.swiper-button-next {
    height: 1rem;
    width: 1rem;
    background: url('../assets/imgs/right@3x.png') no-repeat center/contain;
    right: -1.1rem;
    margin-top: -0.3rem;
    outline: none;
}
</style>